import React, {useContext, useEffect, useState} from 'react';
import './registration.scss';
import {InputField, Button, Loading} from 'components';
import * as Yup from "yup";
import {Formik} from 'formik';

import USER_ICON from 'assets/icons/user_icon.svg';
import PHONE_ICON from 'assets/icons/phone_icon.svg';
import EMAIL_ICON from 'assets/icons/email_icon.svg';
import PASSWORD_ICON from 'assets/icons/password_icon.svg';
import {useNavigate} from "react-router-dom";
import {useRegisterMutation} from "../../operations/mutations/useRegisterMutation";
import jwt_decode from "jwt-decode";
import {SessionContext} from "../../providers/SessionProvider";
import {useLoginMutation} from "../../operations/mutations";

const phoneRegExp = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
// const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/


export const RegistrationFormValidation = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    contact: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required('Phone Number is required'),
    email: Yup.string().required('Email is required').email('Invalid email address'),
    password: Yup.string().required('Password is required'),
    c_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
})

const ERROR_ICON = <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1.00195 1.00024L11.0004 10.9987' stroke='white' stroke-width='1.42857' stroke-linecap='round'/>
    <path d='M10.9985 1L1.00012 10.9984' stroke='white' stroke-width='1.42857' stroke-linecap='round'/>
</svg>;


const Registration = () => {
    const [step, setStep] = useState(0);
    const navigate = useNavigate()
    const {createSession} = useContext(SessionContext);

    const {mutateAsync, isError, isLoading} = useRegisterMutation();
    const {mutateAsync: loginMutateAsync, isLoading: loginLoading} = useLoginMutation();

    const [isRegistrationError, setRegistrationError] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>(
        'A connectivity issue has occurred. Please check your connection and try again.'
    );


    useEffect(() => {
        setRegistrationError(isError);
    }, [isError]);

    useEffect(() => {
        setErrorMessage((msg) => (msg.replace(/(<([^>]+)>)/ig, '')
            .replace("Error:", '')
            .replace('Lost your password?', '')))
    }, [isError]);

    const onSubmit = async (values: any, {setSubmitting}: any) => {
        setSubmitting(false);

        try {
            const addUser = await mutateAsync({
                username: values.first_name[0] + values.last_name,
                name: [values.first_name, values.last_name].join(' '),
                email: values.email,
                password: values.password
            })

            if (addUser) {
                console.log('created')
                try {
                    const data = await loginMutateAsync({identifier: values.email, password: values.password});
                    console.log({data})
                    const payload: any = jwt_decode(data?.data.jwt);
                    // const userInfo = payload.data;
                    payload && createSession({
                        isActive: true,
                        isAuth: true,
                        exp: payload.exp,
                        // payload: userInfo,
                        payload: data.data.user,
                        token: data.data.jwt,
                    });
                    setSubmitting(false);
                    navigate('/app/dashboard')
                } catch (e: any) {
                    setErrorMessage("Account Created, however, there was an issue signing you in. Please navigate to the login page to login");
                }
            }

        } catch (err: any) {
            console.log({err})
            setStep(0)
            setErrorMessage(err?.response.data.error.message)
        }
    }

    return (
        <div className={'registration'}>
            <h1>{step === 0 ? "Hi, Welcome to SBAJ!" : "Almost There!"}</h1>
            <h2>Step <span>{step + 1}</span> of <span>2</span></h2>
            <p>Sign up and start benefiting from our services today.</p>
            {isRegistrationError && <div className='registration_error'>
                <div className='registration_error_circle' onClick={() => setRegistrationError(false)}>
                    {ERROR_ICON}
                </div>
                <h1>Oops!</h1>
                <p>{errorMessage}</p>
            </div>}
            {(isLoading || loginLoading) && (
                <div className={'registration_loading'}>
                    <Loading/>
                </div>
            )}
            <Formik
                validateOnMount={false}
                validateOnChange={true}
                initialValues={{
                    first_name: "",
                    last_name: "",
                    contact: "",
                    email: "",
                    password: "",
                    c_password: ""
                }}
                validationSchema={RegistrationFormValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        {step === 0 &&
                            <div>
                                <InputField
                                    id={"register_first_name"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"First Name"}
                                    name="first_name"
                                    onblur={handleBlur}
                                    error={errors.first_name && touched.first_name}
                                    onchange={handleChange}
                                    message={errors.first_name && touched.first_name && errors.first_name}
                                    inputValue={values.first_name}
                                    image={USER_ICON}
                                />
                                <InputField
                                    id={"register_last_name"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"Last Name"}
                                    name="last_name"
                                    onblur={handleBlur}
                                    error={errors.last_name && touched.last_name}
                                    onchange={handleChange}
                                    message={errors.last_name && touched.last_name && errors.last_name}
                                    inputValue={values.last_name}
                                    image={USER_ICON}
                                />
                                <InputField
                                    id={"register_contact"}
                                    type="contact"
                                    classname="signup__input"
                                    placeholder={"Phone Number"}
                                    name="contact"
                                    onblur={handleBlur}
                                    error={errors.contact && touched.contact}
                                    onchange={handleChange}
                                    message={errors.contact && touched.contact && errors.contact}
                                    inputValue={values.contact}
                                    image={PHONE_ICON}
                                />

                                <Button type={"primary"} isSubmit={false} onclick={() => setStep(1)} text={"Continue"}/>
                            </div>
                        }
                        {step === 1 &&
                            <div>
                                <InputField
                                    id={"register_email"}
                                    type="text"
                                    classname="signup__input"
                                    placeholder={"Email Address"}
                                    name="email"
                                    onblur={handleBlur}
                                    error={errors.email && touched.email}
                                    onchange={handleChange}
                                    message={errors.email && touched.email && errors.email}
                                    inputValue={values.email}
                                    image={EMAIL_ICON}
                                />
                                <InputField
                                    id={"register_password"}
                                    type="password"
                                    classname="signup__input"
                                    placeholder={"Password"}
                                    name="password"
                                    onblur={handleBlur}
                                    error={errors.password && touched.password}
                                    onchange={handleChange}
                                    message={errors.password && touched.password && errors.password}
                                    inputValue={values.password}
                                    image={PASSWORD_ICON}
                                />

                                <InputField
                                    id={"register_c_password"}
                                    type="password"
                                    classname="signup__input"
                                    placeholder={"Confirm Password"}
                                    name="c_password"
                                    onblur={handleBlur}
                                    error={errors.c_password && touched.c_password}
                                    onchange={handleChange}
                                    message={errors.c_password && touched.c_password && errors.c_password}
                                    inputValue={values.c_password}
                                    image={PASSWORD_ICON}
                                />

                                <div className={'registration_buttons'}>
                                    <Button type={"primary"} isSubmit={false} onclick={() => {
                                        setStep(0)
                                    }} text={"Previous"}/>
                                    <Button type={"primary"} isSubmit={true} text={"Register"}/>

                                </div>
                            </div>
                        }
                    </form>
                )}
            </Formik>
            <p className={'tertiary_cta'}>Already have and account? <span
                onClick={() => navigate("/login")}>Sign In</span></p>
        </div>
    );
};

export default Registration;
